require('angular-elastic');
require('angular-credit-cards');

const sct = angular.module('app.sct', [
  'monospaced.elastic',
  'credit-cards',
  require('angular-auth0'),
  require('ng-sortable'),
  require('angular-elastic'),
  require('../components/sct/sctAdmin/sctAdmin').name,
  require('../components/sct/sctChoiceCards/sctChoiceCards').name,
  require('../components/sct/sctProfileCard/sctProfileCard').name,
  require('../components/sct/sctUserNav/sctUserNav').name,
  require('../components/sct/sctAvatar/sctAvatar').name,
  require('../components/sct/sctToaster/sctToaster').name,
  require('../components/sct/sctFooter/sctFooter').name,
]);

sct.constant('SCT_CONFIG', require('../config/sctConfig'));

sct.directive('lbExpiryDate', require('../directives/lbExpiryDate'));
sct.directive('lbPasswordStrength', require('../directives/lbPasswordStrength'));
sct.directive('lbSpinnerButton', require('../directives/lbSpinnerButton'));

sct.service('sctToasterService', require('../components/sct/sctToaster/sctToasterService'));
sct.service('userPeopleService', require('../services/userPeopleService'));
sct.service('userContactService', require('../services/userContactService'));
sct.service('userFeedService', require('../services/userFeedService'));
sct.service('userCardsService', require('../services/userCardsService'));
sct.service('userInviteService', require('../services/userInviteService'));
sct.service('sctUserPermissionsService', require('../services/sctUserPermissionsService'));

sct.filter('userRoleNameFilter', require('../filters/userRoleNameFilter'));

sct.config(['angularAuth0Provider', (angularAuth0Provider) => {
  angularAuth0Provider.init({
    clientID: window.Auth0ClientId,
    domain: window.Auth0Domain,
    responseType: 'token id_token',
    audience: window.Auth0ApiIdentifier
  });
}]);

let bypassCheckingSettings = false;

sct.run(['$window', '$rootScope', '$state', 'AUTH_EVENTS', 'sctUserPermissionsService', 'settingsService', 'userProfileService',
  ($window, $rootScope, $state, AUTH_EVENTS, sctUserPermissionsService, settingsService, userProfileService) => {

  $rootScope.$on(AUTH_EVENTS.sctAuthSuccess, function () {
    if (sct.previousSate && !sct.previousSate.toParams.isPublic) {
      $state.go(app.previousSate.toState, app.previousSate.toParams);
    } else {
      userProfileService.getAny().then((profileResponse) => {
        if (profileResponse.Role === 'DebtorAdmin') {
          $state.go('app.admin');
        } else {
          $state.go('app.home.search');
        }

        window.svelteStore.setTrackingIdentity(profileResponse.TravellerId);
        window.svelteStore.trackUser(profileResponse.Firstname, profileResponse.Lastname, profileResponse.Email, profileResponse.DebtorIdentifier);
      });
    }
  });

  $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
    if (toParams.isPublic)
      return;

    if (!sctUserPermissionsService.permissions.userLevel) {
      event.preventDefault();
      sctUserPermissionsService.checkPermissions(toState, toParams);
    }

    if (sctUserPermissionsService.permissions &&
      toParams.userPermissionLvlRequired &&
      !toParams.userPermissionLvlRequired.includes(sctUserPermissionsService.permissions.userLevel)) {
      event.preventDefault();
      $state.go('app.home.search');
    }

    if (toParams.registrationRequired && !toState.name.includes('app.registration')) {
      if (!sctUserPermissionsService.isRegistered()) {
        event.preventDefault();
        $state.go('app.registration', {}, {location: 'replace'});
      }
    }

    if (toState.name === 'app.registration.profile' && sctUserPermissionsService.isRegistered()) {
      event.preventDefault();
      $state.go('app.home', {}, {location: 'replace'});
    }

    if (!bypassCheckingSettings && fromState.name.includes('app.admin') && toState.name === 'app.home.search') {
      event.preventDefault();
      bypassCheckingSettings = true;
      settingsService.clear();

      settingsService.get().then(() => {
        $state.go(toState.name, {}, {location: 'replace'});
        bypassCheckingSettings = false;
      });
    }
  });
}]);

sct.run(['$rootScope', '$state', '$location', 'angularAuth0', 'AUTH_EVENTS', ($rootScope, $state, $location, angularAuth0, AUTH_EVENTS) =>
  $rootScope.$on(AUTH_EVENTS.logoutSuccess, () => {
    let redirectURL = `${$location.protocol()}://${$location.host()}`;
    let redirectPort = $location.port();

    if(redirectPort) {
      redirectURL += `:${redirectPort}#/login`;
    }

    angularAuth0.logout({
      returnTo: redirectURL
    });
  })
]);


export default sct;



// WEBPACK FOOTER //
// ./src/appSpecificImports/index.sct.js